import { createContext } from 'react';

import { SlotsPortalsMap } from '../../types/slotsState';

const SlotsContentContext = createContext<SlotsPortalsMap>({});
SlotsContentContext.displayName = 'SlotsContentContext';

export { SlotsContentContext };
